import React from "react";
import { FaGithub } from "react-icons/fa";
import { MdArrowOutward } from "react-icons/md";
import { Link } from "react-router-dom";
import seasonal from "../assets/fruits.png";
import nextask from "../assets/nextask.png";

const ProjectCard = ({ src, title, desc, lang, github, link }) => (
  <div
    className="group bg-background border border-border rounded-[2rem] overflow-hidden transition-all duration-500 hover:border-text flex flex-col h-full"
  >
    <div className="aspect-video overflow-hidden bg-secondary relative">
      <img
        src={src}
        alt={title}
        className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
      />
    </div>

    <div className="p-8 flex flex-col flex-grow">
      <div className="flex justify-between items-start mb-3">
        <h3 className="text-2xl font-bold tracking-tighter">{title}</h3>
        <div className="flex gap-4 opacity-60 group-hover:opacity-100 transition-opacity">
          {github && (
            <a href={github} target="_blank" rel="noreferrer" className="hover:text-secondary transition-colors">
              <FaGithub size={20} />
            </a>
          )}
          <a href={link} target="_blank" rel="noreferrer" className="hover:text-secondary transition-colors">
            <MdArrowOutward size={22} />
          </a>
        </div>
      </div>

      <p className="text-secondary text-sm leading-relaxed mb-6 flex-grow font-light">
        {desc}
      </p>

      <div className="flex flex-wrap gap-2 mt-auto">
        {lang.map((tech, i) => (
          <span key={i} className="text-[10px] uppercase tracking-[0.15em] font-bold text-secondary/60 bg-border px-2.5 py-1 rounded-full border border-transparent">
            {tech}
          </span>
        ))}
      </div>
    </div>
  </div>
);

const Projects = () => {
  const projects = [
    {
      id: 1,
      src: seasonal,
      title: "Seasonal",
      desc: "AI-powered produce picker. Helps users find the perfect fruits at the perfect time using computer vision and seasonal data.",
      lang: ["React", "OpenAI", "Tailwind"],
      github: "https://github.com/billie-zhang/Seasonal",
      link: "https://seasonal-app.vercel.app/",
    },
    {
      id: 2,
      src: nextask,
      title: "nexTask",
      desc: "Goal decomposition tool. Breaks down large ambitions into actionable daily tasks using recursive logic.",
      lang: ["Vite", "Tailwind"],
      github: "https://github.com/billie-zhang/nexTask",
      link: "https://thenextask.vercel.app/",
    },
  ];

  return (
    <div id="projects" className="py-32 bg-background">
      <div className="max-w-6xl mx-auto px-6">

        <div className="flex flex-col mb-16 space-y-2">
          <h2 className="text-sm uppercase tracking-[0.5em] text-secondary font-bold ml-2">Featured</h2>
          <h3 className="text-5xl md:text-6xl font-bold tracking-tighter">projects.</h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {projects.map((project) => (
            <ProjectCard key={project.id} {...project} />
          ))}

          <Link
            to="/projects"
            className="group relative bg-secondary/5 border border-border rounded-[2.5rem] p-10 flex flex-col justify-center items-center text-center transition-all duration-500 hover:bg-border hover:border-text h-full min-h-[400px]"
          >
            <div className="mb-6 w-16 h-16 rounded-full bg-background border border-border flex items-center justify-center group-hover:scale-110 group-hover:border-text transition-all duration-500">
              <MdArrowOutward size={28} className="group-hover:text-text transition-colors" />
            </div>

            <h4 className="text-2xl font-bold tracking-tight mb-2">view all projects</h4>
            <p className="text-secondary text-sm font-light max-w-[200px]">
              Explore the full library of experiments and case studies.
            </p>

          </Link>
        </div>
      </div>
    </div>
  );
};

export default Projects;